<template>
  <div>
    <div class="vuse-content-wrapper mt-4">
      <div>
          <v-row >
            <v-col>              
              <h2 class="ml-3">
                {{$t(page+'.Users')}}
                <!--
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <ExcelIcon />
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                -->
                <span class="ml-2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn fab icon small color="info" v-on="on" @click="customers=[];getData()" :loading="loading" class="neu-glow">
                        <v-icon>mdi-sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
                <!--
                <span class="ml-8">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn fab icon small color="info" v-on="on" to="campaigns" class="neu-glow">
                        <v-icon>mdi-mailbox</v-icon>
                      </v-btn>
                    </template>
                    <span>Campagne Marketing</span>
                  </v-tooltip>
                </span>          
                -->      
              </h2>
            </v-col>
       

            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right pr-8">
              <v-btn @click="dialog_range=true">Periodo: {{rangeString}}</v-btn>
            </v-col>              
          </v-row>
          <template v-if="customers.length==0 && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5">
              <v-col cols="12" class="ma-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title>
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                          class="mt-n4"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-data-table
                      :loading="customers.length==0"
                      fixed-header="true"
                      :headers="headers"
                      :items="customers"
                      :items-per-page="5000"
                      :height="wIH - 289"
                      :search="search"
                      loading-text="Loading... Please wait"
                      :hide-default-footer="true"
                      class="mx-5 neu-glow"

                  >              

                    <template v-for="(h,hi) in headers" v-slot:[`header.${h.value}`]="{ header }">
                      <v-tooltip top :key="hi" :class="header">
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{h.text}}</span>
                        </template>
                        <span>{{h.description}}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:[`item.createdDate`]="{ item }">
                      <v-span>{{item.createdDate}}<br />{{item.expiryDate}}</v-span>
                    </template>
                               
                    <template v-slot:[`item.brand`]="{ item }">
                      <div class="image-container" v-if="item.img">
                          <v-img
                            :lazy-src="'/static/users/pictures/tb/'+item.img"
                            max-height="60"
                            max-width="200"
                            :src="'/static/users/pictures/tb/'+item.img"
                          >
                          </v-img> 
                      </div>
                      <v-div v-else>{{item.brand}}</v-div>
                    </template>

                    <template v-slot:[`item.active`]="{ item }">
                      <v-switch color="info" 
                      @click="save(item,'active','account')" 
                      v-model="item.active"
                      :label="item.active?'SI':'NO'"
                      >
                      </v-switch>
                    </template>  

                    <template v-slot:[`item.expired`]="{ item }">
                      <v-switch color="info" 
                      @click="save(item,'expired')" 
                      v-model="item.expired"
                      :label="item.expired<0?'SI':'NO'"
                      >
                      </v-switch>
                    </template>  

                    <template v-slot:[`item.pec`]="{ item }">
                      <v-btn x-small color="primary" @click="openModal(item.uuid,item.userName)" v-model="item.email">Send</v-btn>
                    </template>
                    <template v-slot:[`item.modules`]="{ item }">
                      <v-btn x-small color="primary" @click="dialog_modules_open(item)" v-model="item.modules">Moduli</v-btn>
                    </template>

                    <!--
                    <template v-slot:[`item.password`]="{ item }">
                      <v-btn x-small :color="!item.Password==''?'primary':'secondary'" @click="impersonate(item.email,item.password)">Log</v-btn>
                    </template>
                    -->
                  </v-data-table>
                  </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>
    <v-dialog v-model="msg_modal" max-width="1200">
      <v-card class="overflow-hidden">
        <v-card-title class="text-h5">
          {{$t(page+'.Send a Message')}}
          <v-spacer></v-spacer>
          <v-btn icon @click="msg_modal=false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
          <v-row  class="mt-5">
            <v-col cols="12" md="6">
              <v-img
                src="/static/ob-animated/sent-message-animate.svg"
                lazy-src="/static/ob-animated/sent-message-animate.svg"
                style="height:100%"
              ></v-img>
            </v-col>
            <v-col>
              <v-card-text class="mt-2">
                <p>{{$t(page+'.Send a Message to')+'...'+ username}}</p>
                  <v-text-field
                    :label="$t(page+'.Subject')"
                    :placeholder="$t(page+'.Subject')"
                    outlined
                    v-model="msg.subject"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    v-model="msg.body"
                    name="message"
                    :label="$t(page+'.message')"
                    :placeholder="$t(page+'.message')"
                  ></v-textarea>
                <div class="text-left mt-5">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn 
                        class="mr-5"
                        color="info"
                        @click="msg.body='';msg.subject='';"
                      >{{$t(page+'.Clear')}}</v-btn>
                      <v-btn 
                        :loading="sendingmail"
                        :color="sendbutton_color"
                        @click="messageSend"
                      >{{$t(page+'.'+sendbutton_text)}}</v-btn>
                    </v-col>
                  </v-row>
                  </div>
              </v-card-text>
            </v-col>
          </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="info_dialog" max-width="800">
      <v-card>
        <v-card-title class="text-h5 mb-3"
          >{{$t(page+'.Instructions')}}</v-card-title
        >
        <v-row class="mx-5">
          <v-col md="6" cols="12">
            {{$t(page+'.ShippingDetailsModalInstructions')}}
          </v-col>  
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="info_dialog=false">
            {{$t(page+'.Close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_invoice_text" max-width="600" v-if="selectedCustomer">
      <v-card class="neu-glow pa-3">
        <v-card-title class="text-h5 mb-3">
          Descrizione Fatturazione:
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2" @click="copyToClipboard(invoiceRemarks2)">
                  <v-icon color="info">mdi-clipboard-arrow-up</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Copia negli Appunti</span>
          </v-tooltip>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2"  @click="dialog_invoice_text=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-card-text class="neu-glow pa-3">
          <div v-html="invoiceRemarks"></div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_modules" max-width="1450" v-if="selectedCustomer">
      <v-card class="neu-glow pa-3">
        <v-card-title class="text-h5 mb-3">
          Dettagli Moduli: <span class="info--text ml-2">{{selectedCustomer.brand}}</span>
          <v-spacer></v-spacer>
          <div>
            <v-menu
              v-model="menu[index]"
              :close-on-content-click="false"
              :nudge-right="40"
              color="info"
              min-width="auto"
              
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateForAllModules"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  label="Data Scadenza Moduli (tutti)"
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  class="mr-12"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateForAllModules"
                locale="it"
                dense
                @input="save(item,'expiry','all');menu[index] = false" 
              ></v-date-picker>
            </v-menu> 
          </div>
          <!--        
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2" @click="dialog_confirm=true">
                  <v-icon color="warning">mdi-calendar-lock</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Imposta data odierna come ultimo giorno attivo su tutti i moduli</span>
          </v-tooltip>
          -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2"  @click="dialog_modules=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-card-text class="neu-glow pa-3">
          <v-data-table
              fixed-header="true"
              hide-default-footer
              disable-sort
              dense
              :headers="module_headers"
              :items="selectedCustomer.modules"
              :items-per-page="10000"
              loading-text="Loading... Please wait"
          >
            <template v-for="(h,hi) in module_headers" v-slot:[`header.${h.value}`]="{ header }">
              <v-tooltip top :key="hi" :class="header">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{h.text}}</span>
                </template>
                <span>{{h.description}}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.icon`]="{ item }">
              <v-icon
                :color="item.iconColor"
                :size="32"
              >
              {{item.icon}}
              </v-icon>
            </template>

            <template v-slot:[`item.dPrice`]="{ item }">
              <div>
                {{ item.dPrice}}
              </div>
            </template>

            <template v-slot:[`item.expiry`]="{ item, index }">
                <v-menu
                  v-model="menu[index]"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  color="info"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.expiry"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      color="info"
                      hide-details
                      
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.expiry"
                    locale="it"
                    dense
                    @input="save(item,'expiry');menu[index] = false" 
                  ></v-date-picker>
                </v-menu>               
            </template>

            <template v-slot:[`item.price`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step="1" 
                name="Price"
                hide-details
                @input.native="save(item,'price')" 
                v-model="item.price" 
                :value="(item.price/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.inboundPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="inboundPrice"
                hide-details
                @input.native="save(item,'inboundPrice')" 
                v-model="item.inboundPrice" 
                :value="(item.inboundPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.forwardPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="forwardPrice"
                hide-details
                @input.native="save(item,'forwardPrice')" 
                v-model="item.forwardPrice" 
                :value="(item.forwardPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.forwardMobilePrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="forwardMobilePrice"
                hide-details
                @input.native="save(item,'forwardMobilePrice')" 
                v-model="item.forwardMobilePrice" 
                :value="(item.forwardMobilePrice/1)">
              </v-text-field>
            </template>            

            <template v-slot:[`item.forwardAIPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="forwardAIPrice"
                hide-details
                @input.native="save(item,'forwardAIPrice')" 
                v-model="item.forwardAIPrice" 
                :value="(item.forwardAIPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.TTSPrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="TTSPrice"
                hide-details
                @input.native="save(item,'TTSPrice')" 
                v-model="item.TTSPrice" 
                :value="(item.TTSPrice/1)">
              </v-text-field>
            </template>

            <template v-slot:[`item.WAUtilityMessagePrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="WAUtilityMessagePrice"
                hide-details
                @input.native="save(item,'WAUtilityMessagePrice')" 
                v-model="item.WAUtilityMessagePrice" 
                :value="(item.WAUtilityMessagePrice/1)">
              </v-text-field>
            </template>  

            <template v-slot:[`item.WAMarketingMessagePrice`]="{ item }">
              <v-text-field 
                outlined
                dense
                reverse
                type="number"
                step=".01" 
                name="WAMarketingMessagePrice"
                hide-details
                @input.native="save(item,'WAMarketingMessagePrice')" 
                v-model="item.WAMarketingMessagePrice" 
                :value="(item.WAMarketingMessagePrice/1)">
              </v-text-field>
            </template>                        

          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_confirm"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Confermi Operazione?
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="save(selectedCustomer.accountId,'all','dueDate')">
                <v-icon color="info">mdi-check-bold</v-icon>
              </v-btn>
            </template>
            <span>Esegui</span>
          </v-tooltip> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_confirm=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>                     
        </v-card-title>
      </v-card>
    </v-dialog> 
    <v-dialog
      v-model="dialog_range"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Scegli Periodo
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_range=false;customers=[];getData()">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4">
          <v-date-picker
            v-model="dateRange"
            scrollable
            range
            color="info"
            show-adjacent-months
            full-width
            :first-day-of-week="1"
            locale="it"
            show-week
          >
          </v-date-picker>
        </v-card>
      </v-card>
    </v-dialog>          
    <v-snackbar v-model="snackbar" top right :width="120" :color="snackbar_color" style='z-index:20001;'>
      <span>{{snackbar_message}}</span>
    </v-snackbar>
  </div>
</template>
<style scoped>
.v-input__slot{
  min-height:30px!important;
  max-height:20px!important;
}
</style>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";
import _ from 'lodash'

export default {
  components: { NoData, SkeletonRevenue, ExcelIcon },
  computed : {
    ...mapGetters(["settings"]),
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
    today:function()
    {
      var yourDate=new Date();
      const of = yourDate.getTimezoneOffset()
      yourDate = new Date(yourDate.getTime() - (of*60*1000))
      return yourDate.toISOString().split('T')[0]
    },  
  },
  data() {
    return {
      page: "Boss",
      UserID:null,
      username:'',
      formValid:true,
      pl_dialog:false,
      dialog_modules:false,
      dialog_invoicing:false,
      dialog_range:false,
      dialog_confirm:false,
      dialog_invoice_text:false,
      active_pricelist:null,
      custom_pricelist:[],
      menu:[],
      msg_modal:false,
      msg:{},
      htmlBody:'',
      wIH:window.innerHeight,
      loading: true,
      errorid: null,
      search: '',
      customers: [],
      info_dialog:false,
      snackbar:false,
      snackbar_message:'',
      snackbar_color:'',
      sendbutton_color:'info',
      sendbutton_text:'Send',
      sendingmail:false,
      //pickedDate:null,
      selectedCustomer:null,
      dateRange:[(new Date(new Date().getFullYear(),new Date().getMonth(), 2)).toISOString().substring(0, 10),(new Date(new Date().getFullYear(),new Date().getMonth()+1, 1)).toISOString().substring(0, 10)],
      rangeString:null,
      invoiceRemarks:'',
      invoiceRemarks2:'',
      forceExpiry:null,
      dateForAllModules:null,
      headers: [
        //{ text: 'Log', value: 'password' },

        { text: 'Attivo',     value: 'active',class:'text-button font-weight-bold' },
        //{ text: 'Scaduto',    value: 'expired',class:'text-button font-weight-bold' },
        { text: 'Ag',     value: 'agentId',align:'start',class:'text-button font-weight-bold' },
        { text: 'Start/Stop',value: 'createdDate', align: 'start',class:'text-button font-weight-bold'},
        //{ text: 'Scadenza',   value: 'expiryDate', align: 'start',class:'text-button font-weight-bold'},
        { text: 'GG',     value: 'duration', align: 'start',class:'text-button font-weight-bold'},
        //{ text: 'Group', value: 'group' },
        { text: 'Insegna',    value: 'brand', align: 'center',class:'text-button font-weight-bold' },
        { text: 'Città',      value: 'city', align: 'start',class:'text-button font-weight-bold' },
        //{ text: 'Telefono',   value: 'phone', align: 'center',class:'text-button font-weight-bold' },
        //{ text: 'Scadenza',   value: 'expiry', align: 'center',class:'text-button font-weight-bold' },        
        { text: 'PEC',        value: 'pec', align: 'center',class:'text-button font-weight-bold' },    
        /*
        { text: 'PBX',  value: 'totCostPBX',class:'text-button font-weight-bold error--text', description:'Costo Segreteria',align: 'end' },
        { text: 'PBX', value: 'totAmountPBX',class:'text-button font-weight-bold success--text', description:'Ricavo Segreteria',align: 'end' },
        //{ text: 'FWD',        value: 'FWD_Amount',class:'text-button font-weight-bold success--text', description:'Imp. Trasferimenti',align: 'end' },
        { text: 'WA',  value: 'totCostWA',class:'text-button font-weight-bold error--text', description:'Costi WhatsApp',align: 'end' },
        { text: 'WA',  value: 'totAmountWA',class:'text-button font-weight-bold success--text', description:'Ricavo WhatsApp',align: 'end' },
        { text: 'Totali €',        value: 'totCosts',class:'text-button font-weight-bold info--text', description:'Totali Costi/Ricavi',align: 'end' },
        { text: 'Margine',        value: 'priceWAUtility',class:'text-button font-weight-bold', description:'Margine %',align: 'end' },
        
        { text: 'Dettagli',   value: 'cid', align: 'center' ,class:'text-button font-weight-bold', description:'Emetti Fattura',align: 'end'},
        */
        { text: 'Moduli',     value: 'modules', align: 'center' ,class:'text-button font-weight-bold', description:'Prezzi Moduli',align: 'end'},
      ],
      module_headers:[
        { text: '', value: 'icon', align: 'center',class:'text-button font-weight-bold' },
        { text: 'Modulo', value: 'productName', align: 'start',class:'text-button font-weight-bold' },
        { text: 'Scadenza', value: 'expiry', align: 'center', width:"200",class:'text-button font-weight-bold' },
        { text: 'Listino', value: 'dPrice', align: 'end', width:"120",class:'text-button font-weight-bold' },
        { text: 'Prezzo', value: 'price', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Prezzo Modulo' },
        //{ text: 'TTS', value: 'TTSPrice', align: 'center',width: "120" },
        { text: 'INB', value: 'inboundPrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Chiamate in Entrata' },
        { text: 'FWD', value: 'forwardPrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Trasferimento chiamate i a Fisso' },
        { text: 'FWD M', value: 'forwardMobilePrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Trasferimento chiamate a Mobile' },
        { text: 'FWD AI', value: 'forwardAIPrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Trasferimenti ad AI' },
        { text: 'WA U', value: 'WAUtilityMessagePrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Prezzo Messaggio WA Utility' },
        { text: 'WA M', value: 'WAMarketingMessagePrice', align: 'center',width: "120",class:'text-button font-weight-bold', description:'Prezzo Messaggio WA Marketing' },
      ],
      priceRules: [ 
            v => ( v >= 0 ) || this.$t(this.page+".Rate cannot be negative"),
            v => ( v <= 100 ) || this.$t(this.page+".To indicate ")+v+"% "+this.$t(this.page+'.enter')+' '+ v/100
        ],       
      rateRules: [ 
            v => ( v >= 0 ) || this.$t(this.page+".Rate cannot be negative"),
            v => ( v <= 100 ) || this.$t(this.page+".To indicate ")+v+"% "+this.$t(this.page+'.enter')+' '+ v/100
        ],              
    };
  },
  created(){
    this.$vuetify.theme.dark = true
    this.getData()
  },
  watch : {

  },
  methods:
  {
    copyToClipboard(txt)
    {
      navigator.clipboard.writeText(txt);
      this.snackbar_color="success"
      this.snackbar_message ='Copiato negli Appunti';
      this.snackbar = true;
    },    
    range_string()
    {
      console.log(260,this.dateRange)
      var date = new Date(this.dateRange[0]), y = date.getFullYear(), m = date.getMonth();
      var date2 =new Date(this.dateRange[1])
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);
      this.monthName=firstDay.toLocaleString('it',{month:"long"})
      console.log(683,firstDay,lastDay,firstDay.toLocaleDateString('it', options) + ' - ' + lastDay.toLocaleDateString('it', options))
      const options={ year: 'numeric', month: '2-digit', day: '2-digit' };
      //return new Date(this.dateRange[0]).toLocaleDateString('it', options) + ' - ' + new Date(this.dateRange[1]).toLocaleDateString('it', options)
      //var k=firstDay.toLocaleDateString('it', options) + ' - ' + lastDay.toLocaleDateString('it', options)
      var k=date.toLocaleDateString('it', options) + ' - ' + date2.toLocaleDateString('it', options)
      this.rangeString=k;
      console.log(867,k,this.monthName)
      //return k
    },    
    save: _.debounce(function (item,field,type='') {
      let jwt=sessionStorage.getItem('jwt');
      console.log(372,item,field,type,this.selectedCustomer);
      let vl='';
      let payload='';
      switch (type)
      {
        case 'all'://dateForAll
          vl=this.dateForAllModules;
          payload={"jwt":jwt,"payload":{"action":"edit_user","table": "User_Products", "field": field, "value": vl, "accountId":this.selectedCustomer.accountId, "productId":'all'}};

        break;
        case 'dueDate': //set expired all Modules and also Accounts
          vl=item[field]==='0'||item[field]===''?null:item[field];
          payload={"jwt":jwt,"payload":{"action":"expire_products_and_account", "table": "Accounts","field": field, "value": vl,"accountId":item, "productId":'all'}};
        break;
        case 'account': //disable account (cannot login)
          vl=item[field]==='0'||item[field]===''?null:item[field];
          payload={"jwt":jwt,"payload":{"action":"edit_accounts", "table": "Accounts","field": field, "value": vl,"accountId":item}};
        break;
        default:
          vl=item[field]==='0'||item[field]===''?null:item[field];
          payload={"jwt":jwt,"payload":{"action":"edit_user","table": "User_Products", "field": field, "value": vl, "productId": item.productId , "accountId":this.selectedCustomer.accountId}};
      }
      /*
      let payload=type=='dueDate'?{"jwt":jwt,"payload":{"action":"edit_accounts", "table": "Accounts","field": field, "value": vl,"accountId":item}}
      :{"jwt":jwt,"payload":{"action":"edit_user","table": "User_Products", "field": field, "value": vl, "productId": item.productId , "accountId":this.selectedCustomer.accountId}};
      */
      console.log(374,vl,payload,this.formValid)
      if(this.formValid)
      {
        this.update_db(payload)
      }
      else
      {
        console.log(441,'invalid values in form')
        this.snackbar_color='error';
        this.snackbar_message=this.$t(this.page+'.Invalid value/s in a field: Change not saved');
        this.snackbar=true;
      }

    }, 1000),     
    async update_db(payload){
      
      try
      {
          const res = await this.$http.post('/boss/actions.php', payload);
          //const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,"payload":{"action":"pricelist","field":field,"userid":item.uuid,"value":value}});
          switch (res.data.errorid)
          {
            case '0':
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              console.log(257,res.data.message);
              this.snackbar=true;
               console.log(259,this.snackbar);
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
            default:
              this.snackbar_color='red darken-2';
              this.snackbar_message=res.data.message;
          }
      }
      catch(e)
      {
          console.log(264,e);
          this.snackbar_color='red darken-2';
          this.snackbar_message='Connection Error - Try Later';
      }
      console.log(276)
      this.snackbar=true;
    },
    /*  
    async toggle(item,field,type=''){
      let jwt=sessionStorage.getItem('jwt');
      try
      {
          //'{"table": "PriceLists", "field": "active", "value": 1, "key": "id", "keyValue": 6}'
          console.log(372,item,field,type);
          let vl=item[field]==='0'||item[field]===''?null:item[field];
          let payload=type=='cpl'?{"jwt":jwt,"payload":{"action":"edit_custom_pl", "field": field, "value": vl, "pricelistId": item.pricelistId,"uuid":item.uuid}}:{"jwt":jwt,"payload":{"action":"edit_user","table": "Users", "field": field, "value": vl, "key": "uuid", "keyValue": item.uuid}};
         
          console.log(374,vl,payload)
          const res = await this.$http.post('/boss/actions.php', payload);
          //const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,"payload":{"action":"pricelist","field":field,"userid":item.uuid,"value":value}});
          switch (res.data.errorid)
          {
            case '0':
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              console.log(257,res.data.message);
              this.snackbar=true;
               console.log(259,this.snackbar);
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
            default:
              this.snackbar_color='red darken-2';
              this.snackbar_message=res.data.message;
          }
      }
      catch(e)
      {
          console.log(264,e);
          this.snackbar_color='red darken-2';
          this.snackbar_message='Connection Error - Try Later';
      }
      console.log(276)
      this.snackbar=true;
    },
    */
    dialog_modules_open(item)
    {
      this.dialog_modules=true;
      this.selectedCustomer=item;
    },
    openModal(userid,username)
    {
      this.msg_modal=true;
      this.msg.userid=userid;
      this.username=username;
      this.sendbutton_color='info';
      this.sendbutton_text='Send';
    },
    async messageSend(){
      let jwt=sessionStorage.getItem('jwt');
      this.msg.action='message_send';
      if (this.sendbutton_text=='Send')
      {
        this.sendingmail=true;
        console.log({"jwt":jwt,'action':'messagesend','userid':JSON.stringify(this.msg)});
        try
        {
            const res = await this.$http.post('/boss/actions.php', {"jwt":jwt,'payload':this.msg});
            switch (res.data.errorid)
            {
              case '0':
                this.snackbar_color='success';
                this.snackbar_message=res.data.message;
                console.log(298,res.data.message);
                this.snackbar=true;
                console.log(300,this.snackbar);
                this.sendbutton_color='primary';
                this.sendbutton_text='Sent';
              break;

              case '0006':
                this.$router.push('/auth/login').catch(() => {});
              break;
              default:
                this.snackbar_color='red darken-2';
                this.snackbar_message=res.data.message;
            }
        }
        catch(e)
        {
            console.log(e);
            this.snackbar_color='red darken-2';
            this.snackbar_message='Connection Error - Try Later';
        }
        this.sendingmail=false;
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message='Message already sent';
      }
        console.log(317)
        this.snackbar=true;
    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"jwt":jwt};
      window.location.href='/ajax/boss/customers_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async getData(){
      let jwt=sessionStorage.getItem('jwt');
      this.range_string();
      this.loading=true;
      try
      {
          const payload=JSON.stringify({"dateRange": this.dateRange,"date": this.date,"action":"getCustomers"});
          const res = await this.$http.post('/boss/users.php', payload );
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.customers=res.data.payloads.allAccounts;
              //console.log(this.customers);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
    async impersonate(e,p)
    {
      if(p)
      {
        this.loader=true;    
    	  //localStorage.clear();
	      localStorage.removeItem('user');
	      //sessionStorage.clear();
	      sessionStorage.removeItem('jwt');
        try
        {
          const res = await this.$http.post('/auth/login.php', {email: e, password: p, rememberme: true})
          this.errorid=res.data.errorid;
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            res.data.user.jwt=res.data.jwt;
            this.$store.dispatch("setUser", res.data.user); 
            this.$store.dispatch("setFixings", res.data.fixings);
            //this.$store.dispatch("setLocale", res.data.user.locale);
            //this.$store.dispatch("setCurrency", res.data.user.currency);
            //this.$store.dispatch("set_timeframe", res.data.user.timeframe); 
            
            if (res.data.ls_user)
            {
              localStorage.setItem('user', JSON.stringify(res.data.ls_user));
              //localStorage.setItem('user', res.data.user);
            }
            else
            {
              localStorage.removeItem('user');
            }
            this.$router.push('/'+res.data.user.landingpage).catch(() => {});
          }
          else
          {
            this.message=res.data.message;
            this.dialog=true;
          }
        }       
        catch(e)
        {
          this.$router.push('/auth/login').catch(() => {});
        }
        this.loader=false;
      }
      else
      {
        this.snackbar=true;
        this.snackbar_message='Missing PWD';
        this.snackbar_color='red';
      }
    },
  }
};
</script>
<style>
.v-data-table-header th {
  white-space: nowrap;
}
   .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%; /* Ensures centering within the cell */
      }
</style>